import React, { FC } from 'react';
import { useIsDesktop } from '../hooks/useIsDeskTop';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { RootStackParamList, RootTabParamList } from './types';
import { STYLE_VARS } from '../constants/style-vars';
import { Image } from '../components/Image';
import { MyBookings, MyOrders, MyAccount, Home } from '../screens';
import { IS_WEB } from '../constants/platform';
import { addBase64Prefix } from '../services/addBase64Prefix';
import { orders_white, account_white } from '../assets/base64';
import { View } from 'react-native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import MenuStack from './menu-stack';
import { useSelector } from 'react-redux';
import { RootState } from '../services/redux';

const BottomTab = createBottomTabNavigator<RootTabParamList>();

interface TabItemProps {
  props: {
    focused: boolean;
    color: string;
    size: number;
  };
  icon: any;
}

const TabItem: FC<TabItemProps> = ({ props, icon }) => {
  return (
    <View style={{ flexDirection: 'column', alignItems: 'center' }}>
      {props.focused && (
        <View
          style={{
            width: 55,
            height: 2,
            position: 'absolute',
            bottom: -18,
            backgroundColor: STYLE_VARS.kccDanger,
            zIndex: 10,
          }}
        />
      )}
      <Image source={icon} style={{ width: 28, height: 28 }} />
    </View>
  );
};

type BottomTabsNavigationProp = NativeStackNavigationProp<
  RootStackParamList,
  'Root'
>;

export interface MyBookingsProps {
  navigation: BottomTabsNavigationProp;
}

const BottomTabs: FC<MyBookingsProps> = ({ navigation }) => {
  const isDesktop = useIsDesktop();
  const auth = useSelector((redux: RootState) => redux.authReducer);
  return (
    <BottomTab.Navigator
      sceneContainerStyle={[
        {
          backgroundColor: 'white',
        },
      ]}
      screenOptions={{
        tabBarStyle: {
          backgroundColor: STYLE_VARS.primaryColor,
          display: (isDesktop() || auth.loggedin === false) ? 'none' : 'flex',
        },
      }}
      initialRouteName="HomeTab"
    >
      <BottomTab.Screen
        name="HomeTab"
        component={Home}
        options={{
          tabBarInactiveTintColor: 'white',
          tabBarActiveTintColor: 'white',
          tabBarLabel: 'HOME',
          headerShown: false,
          tabBarIcon: (props) => (
            <TabItem props={props} icon={require('../assets/home-white.png')} />
          ),
        }}
      />
      {auth.loggedin === true && (
        <>
          <BottomTab.Screen
            name="MyBookingsTab"
            component={MyBookings}
            options={{
              tabBarInactiveTintColor: 'white',
              tabBarActiveTintColor: 'white',
              tabBarLabel: 'MY BOOKINGS',
              headerShown: false,
              tabBarIcon: (props) => (
                <TabItem
                  props={props}
                  icon={require('../assets/bookings-white.png')}
                />
              ),
            }}
          />
          <BottomTab.Screen
            name="MyOrdersTab"
            component={MyOrders}
            options={{
              tabBarInactiveTintColor: 'white',
              tabBarActiveTintColor: 'white',
              tabBarLabel: 'MY ORDERS',
              headerShown: false,
              tabBarIcon: (props) => (
                <TabItem
                  props={props}
                  icon={
                    IS_WEB
                      ? addBase64Prefix(orders_white)
                      : require('../assets/orders-white.png')
                  }
                />
              ),
            }}
          />
          <BottomTab.Screen
            name="MyAccountTab"
            component={MyAccount}
            options={{
              tabBarInactiveTintColor: 'white',
              tabBarActiveTintColor: 'white',
              tabBarLabel: 'MY ACCOUNT',
              headerShown: false,
              tabBarIcon: (props) => (
                <TabItem
                  props={props}
                  icon={
                    IS_WEB
                      ? addBase64Prefix(account_white)
                      : require('../assets/account-white.png')
                  }
                />
              ),
            }}
          />
          <BottomTab.Screen
            name="MenuTab"
            component={MenuStack}
            listeners={{
              tabPress: () => {
                if (navigation.canGoBack()) {
                  navigation.popToTop();
                  navigation.navigate('Root', {
                    screen: 'MenuTab',
                    params: {
                      screen: 'Menu',
                    },
                  });
                }
              },
            }}
            options={{
              tabBarInactiveTintColor: 'white',
              tabBarActiveTintColor: 'white',
              tabBarLabel: 'MENU',
              headerShown: false,
              tabBarIcon: (props) => (
                <TabItem props={props} icon={require('../assets/menu-white.png')} />
              ),
            }}
          />
        </>
      )}
    </BottomTab.Navigator>
  );
};

export default BottomTabs;
